:root {
  --jolojo-ui-primary-color: #3b82f6;
  --jolojo-ui-secondary-color: var(--jolojo-ui-grey-6);
  --jolojo-ui-destructive-color: rgb(188, 62, 62);
  --jolojo-ui-success-color: rgb(62, 188, 62);

  --jolojo-ui-bg-1: hsl(240, 100%, 99%);

  --jolojo-ui-grey-1: hsl(240, 4%, 95%);
  --jolojo-ui-grey-2: hsl(240, 4%, 80%);
  --jolojo-ui-grey-3: hsl(240, 4%, 70%);
  --jolojo-ui-grey-4: hsl(240, 4%, 60%);
  --jolojo-ui-grey-5: hsl(240, 4%, 50%);
  --jolojo-ui-grey-6: hsl(240, 4%, 40%);
  --jolojo-ui-grey-7: hsl(240, 4%, 30%);
  --jolojo-ui-grey-8: hsl(240, 4%, 20%);

  --jolojo-ui-xs-font-size: 12px;
  --jolojo-ui-sm-font-size: 14px;
  --jolojo-ui-md-font-size: 16px;
  --jolojo-ui-lg-font-size: 20px;
  --jolojo-ui-xl-font-size: 24px;

  --jolojo-ui-xs-gap: 4px;
  --jolojo-ui-sm-gap: 8px;
  --jolojo-ui-md-gap: 12px;
  --jolojo-ui-lg-gap: 16px;
  --jolojo-ui-xl-gap: 24px;
  --jolojo-ui-xxl-gap: 32px;
  --jolojo-ui-xxxl-gap: 48px;

  --jolojo-ui-xs-padding: 4px;
  --jolojo-ui-sm-padding: 8px;
  --jolojo-ui-md-padding: 12px;
  --jolojo-ui-lg-padding: 16px;
  --jolojo-ui-xl-padding: 24px;
  --jolojo-ui-xxl-padding: 32px;

  --jolojo-ui-xs-border-radius: 2px;
  --jolojo-ui-sm-border-radius: 4px;
  --jolojo-ui-md-border-radius: 8px;
  --jolojo-ui-lg-border-radius: 12px;
  --jolojo-ui-xl-border-radius: 16px;
  --jolojo-ui-xxl-border-radius: 22px;

  --jolojo-ui-input-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.jolojo-ui-label {
  font-size: var(--jolojo-ui-sm-font-size);
  margin-left: var(--jolojo-ui-xs-gap);
  color: var(--jolojo-ui-grey-5);
  text-wrap: nowrap;
}
